import React from 'react';
import InfoBoxImgTextLinks from './InfoBoxImgTextLinks';

interface InfoBoxData {
  title: string;
  image?: {
    src: string;
    alt: string;
    className?: string;
  };
  text: string;
  links: {
    text: string;
    url: string;
  }[];
  gap?: string;
}

interface InfoBoxesSectionProps {
  boxes: InfoBoxData[];
  columns?: number;
  containerClassName?: string;
}

const InfoBoxesSection: React.FC<InfoBoxesSectionProps> = ({
  boxes,
  columns = 3,
  containerClassName = '',
}) => {
  const gridClass =
    columns === 2
      ? 'grid gap-y-10 md:gap-5 grid-cols-1 md:grid-cols-2'
      : columns === 3
        ? 'grid gap-y-10 xl:gap-5 grid-cols-1 xl:grid-cols-3'
        : columns === 4
          ? 'grid gap-y-10 md:gap-0 grid-cols-1 md:grid-cols-4'
          : 'grid gap-y-10 grid-cols-1';

  return (
    <section className={`w-full ${containerClassName}`}>
      <div className={gridClass}>
        {boxes.map((box, index) => (
          <InfoBoxImgTextLinks key={index} {...box} />
        ))}
      </div>
    </section>
  );
};

export default InfoBoxesSection;
